import HeaderBar from "components/HeaderBar";
import Loading from "components/Loading";
import Page from "components/Page";
import { useState } from "react";
import { certGETj } from "lib/API";
import SearchResult from "components/SearchResult";
import { pluralN } from "lib/useful";
import Input from "components/Input";
import { Button, ButtonPrimary } from "components/Buttons";
import Toggle from "components/Toggle";

const summaryInterestingKeys = [
  "dest",
  "spec",
  "extColour",
  "trimColour",
  "hoodColour",
];

function Search() {
  const [searchArray, setSearchArray] = useState(["", "", ""]);
  function handleSet(k, v) {
    setSearchArray((sa) => sa.map((sam, sami) => (sami === k ? v : sam)));
  }
  const s = searchArray.map((sa) => sa.trim()).join("");
  const disabled = !s;

  const [results, setResults] = useState(null);
  const [loading, setLoading] = useState(false);

  const [summaryMode, setSummaryMode] = useState(true);

  async function doSearch() {
    setLoading(true);
    const r = await certGETj(
      `search3?${searchArray.map((s) => `search=${encodeURIComponent(s)}`).join("&")}`,
    );
    if (r.success) {
      setResults(r.data);
      setLoading(false);
    }
  }

  let summaryKeys = {};

  for (const r of results ?? []) {
    for (const [k, v] of Object.entries(r.result)) {
      // Initialize the key group if it doesn't exist
      if (!summaryKeys[k]) summaryKeys[k] = {};

      // Direct O(1) lookup/increment
      if (!summaryKeys[k][v]) {
        summaryKeys[k][v] = { value: v, count: 1 };
      } else {
        summaryKeys[k][v].count++;
      }
    }
  }

  // Convert the objects back into sorted arrays
  for (const k of Object.keys(summaryKeys)) {
    summaryKeys[k] = Object.values(summaryKeys[k]).sort(
      (a, b) => b.count - a.count,
    );
  }

  return (
    <Page title="Search3">
      {loading ? (
        <Loading />
      ) : (
        <>
          <HeaderBar>
            {searchArray.map((sa, sai) => (
              <Input
                key={sai}
                value={sa}
                setValue={(v) => handleSet(sai, v)}
                label={
                  sai === 0
                    ? `Search for... (cAsE insensitive)`
                    : `... AND search for ${sa.trim() === "" ? "(blanks are ignored)" : ""}`
                }
                onEnter={doSearch}
              />
            ))}
            <div className="btn-group mt-4">
              <Button onClick={() => setSearchArray((sa) => [...sa, ""])}>
                + add search box
              </Button>
              <ButtonPrimary onClick={doSearch} disabled={disabled}>
                Search &gt;&gt;
              </ButtonPrimary>
            </div>
            {results?.length > 1 && (
              <Toggle
                left
                value={summaryMode}
                setValue={setSummaryMode}
                label="Summary mode"
              />
            )}
          </HeaderBar>
          <div className="p-2">
            {results === null ? null : results?.length > 1 && summaryMode ? (
              <>
                <p>{pluralN(results.length, "result")}</p>
                {results.length > 0 &&
                  summaryInterestingKeys.map((k) => (
                    <div key={k}>
                      <h2 className="font-semibold text-lg">{k}</h2>
                      <table>
                        <tbody>
                          {summaryKeys[k]?.map((sk) => (
                            <tr key={sk.value}>
                              <td className="text-right pr-1 w-14">
                                {sk.count}
                              </td>
                              <td className="border-l pl-2">{sk.value}</td>
                            </tr>
                          )) ?? (
                            <tr>
                              <td>No results</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  ))}
              </>
            ) : (
              <>
                <p>
                  {(results?.length ?? 0) === 0
                    ? "No results"
                    : results.length > 100
                      ? "more than 100 results"
                      : pluralN(results.length, "result")}
                </p>
                {results !== null &&
                  results.length < 100 &&
                  results.map((r, ri) => <SearchResult key={ri} r={r} />)}
                {results !== null && results.length >= 100 && (
                  <>
                    <p>Too many results &mdash; be more specific</p>
                    <h2 className="mt-4">Here are the first 100 results:</h2>
                    {results.slice(0, 100).map((r, ri) => (
                      <SearchResult key={ri} r={r} />
                    ))}
                  </>
                )}
              </>
            )}
          </div>
        </>
      )}
    </Page>
  );
}

export default Search;
